import React from 'react';
import './DisclaimerFooter.css';

// The standard sitewide disclaimer sentence, prepended to every page's footer
// except Home (which carries its own sitewide wording).
export const STANDARD_DISCLAIMER =
  'This web page is not an official document of the Town of Brookline or its Select Board.';

// Inline disclaimer block shown at the bottom of a page's content, in the shared
// "Disclaimer" (amber) colors. Deliberately not a dialog — no close button, not
// fixed; it just flows with the content. (It replaced an earlier modal, which
// has since been deleted, so a reader could not dismiss the disclaimer and then
// forget it was there.)
// `children` is the page-specific text; the standard sentence is prepended above
// it (with a line break) unless `standardPrefix` is false.
function DisclaimerFooter({ children, standardPrefix = true }) {
  return (
    <aside className="disclaimer-footer" aria-label="Disclaimer">
      <p className="disclaimer-footer-label">Disclaimer</p>
      {standardPrefix && <p>{STANDARD_DISCLAIMER}</p>}
      {children}
    </aside>
  );
}

export default DisclaimerFooter;
